import ViewTaskCtrl from '../../tasks/ViewTaskCtrl';
import AnnouncementModalCtrl from '../AnnouncementModalCtrl';
import modalViewUrl from '../../tasks/modal-view.html';
import modalAnnouncementUrl from '../modal-announcement.html';
import modalTorViewUrl from '../../shifts/modal-tor-view.html';
import modalShiftViewUrl from '../../shifts/modal-shift-view.html';
import timesheetModalUrl from '../../timeclock/modal-timesheet.html';
import ShiftSwapNotificationModalCtrl from '../../shifts/shift-swap/ShiftSwapNotificationModalCtrl';
import shiftSwapNotificationModalUrl from '../../shifts/shift-swap/shift-swap-notification-modal.html';
import SelfInviteNotificationModalCtrl from '../manage/users/selfInvite/SelfInviteNotificationModalCtrl';
import selfInviteNotificationModalUrl from '../manage/users/selfInvite/self-invite-notification-modal.html';
import ShiftAcceptanceNotificationModalCtrl from '../../shifts/shift-acceptance/ShiftAcceptanceNotificationModalCtrl';
import shiftAcceptanceNotificationModalUrl from '../../shifts/shift-acceptance/shiftAcceptanceNotificationModal.html';

import { REACT_NOTIFICATION_TYPES, REACT_NOTIFICATION_ROUTES } from './notificationModal.consts';

export default class NotificationModal {
  constructor(
    Authentication,
    ConversationService,
    TaskCollection,
    Restangular,
    ShiftUtils,
    ReactNotificationService,
    sdk,
    $state,
    $window,
    $uibModal
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      ConversationService,
      TaskCollection,
      Restangular,
      ShiftUtils,
      ReactNotificationService,
      sdk,
      $state,
      $window,
      $uibModal,
    });
  }

  getNotificationTaskModal(notification) {
    const { TaskCollection } = this;
    const modalView = modalViewUrl;
    const ctrlSelector = ViewTaskCtrl;
    const resolveObj = {
      task() {
        if (notification.type === 'task_cancelled') {
          notification.items[0].deleted = true;
        }

        if (!TaskCollection.allTasks) {
          TaskCollection.allTasks = [];
          TaskCollection.addOrEditTask(notification.items[0]);
        } else {
          const task = TaskCollection.allTasks.find((t) => t.id === notification.items[0].id);

          if (!task) {
            // e.g. task_cancelled notification
            TaskCollection.addOrEditTask(notification.items[0]);
          } else {
            notification.items[0] = task;
          }
        }

        const task = notification.items[0];
        return TaskCollection.getTaskDetails(task);
      },
      notification() {
        return notification;
      },
    };

    return {
      modalView,
      ctrlSelector,
      resolveObj,
    };
  }

  getNotificationAnnouncementModal(notification) {
    const modalView = modalAnnouncementUrl;
    const ctrlSelector = AnnouncementModalCtrl;
    const resolveObj = {
      announcement() {
        return notification.items[0];
      },
      notification() {
        return notification;
      },
    };

    return {
      modalView,
      ctrlSelector,
      resolveObj,
    };
  }

  getNotificationLeaveModal(notification) {
    if (typeof notification.items[0].dtstart === 'string') {
      notification.items[0].dtstart = new Date(notification.items[0].dtstart);
    }
    if (typeof notification.items[0].dtend === 'string') {
      notification.items[0].dtend = new Date(notification.items[0].dtend);
    }

    const { Restangular } = this;
    const modalView = modalTorViewUrl;
    const controllerProvider = async () =>
      (await import(/* webpackChunkName: "shifts" */ '../../shifts/ViewTimeOffRequestCtrl'))
        .default;
    const resolveObj = {
      request() {
        const timeOff = notification.items[0];
        return timeOff.restangularized
          ? timeOff
          : Restangular.restangularizeElement(null, timeOff, 'leave');
      },
      notification() {
        return notification;
      },
    };

    return {
      modalView,
      controllerProvider,
      resolveObj,
    };
  }

  getNotificationShiftModal(notification) {
    if (notification.type === 'shift_pending_acceptance' && notification.items?.length > 1) {
      return {
        modalView: shiftAcceptanceNotificationModalUrl,
        ctrlSelector: ShiftAcceptanceNotificationModalCtrl,
        resolveObj: {
          notification: () => ({ ...notification }),
        },
      };
    }

    return {
      modalView: modalShiftViewUrl,
      controllerProvider: async () =>
        (await import(/* webpackChunkName: "shifts" */ '../../shifts/ViewShiftCtrl')).default,
      resolveObj: {
        shift: () => notification.items[0],
        notification: () => notification,
        fromExchange: () => false,
        activityLogItem: () => null,
      },
    };
  }

  getNotificationTimesheetsModal(notification) {
    const extendShiftModel = this.sdk('model-extensions/extendShiftModel');
    return {
      modalView: timesheetModalUrl,
      ctrlSelector($scope, $uibModalInstance) {
        'ngInject';

        $scope.modal = $uibModalInstance;
        $scope.event = extendShiftModel(notification.items[0]);
      },
    };
  }

  getNotificationShiftSwapModal(notification) {
    if (notification.type === 'exchange_double_rejected') {
      const { offererShift } = notification.items[0];
      return {
        modalView: modalShiftViewUrl,
        controllerProvider: async () =>
          (await import(/* webpackChunkName: "shifts" */ '../../shifts/ViewShiftCtrl')).default,
        resolveObj: {
          shift: () => offererShift,
          notification: () => notification,
          fromExchange: () => false,
          activityLogItem: () => null,
        },
      };
    }

    if (notification.type === 'exchange_double_approved') {
      const { offereeShift, offererShift, offeree } = notification.items[0];
      const shiftToDisplay =
        this.Authentication.user.id === offeree.id ? offererShift : offereeShift;

      return {
        modalView: modalShiftViewUrl,
        controllerProvider: async () =>
          (await import(/* webpackChunkName: "shifts" */ '../../shifts/ViewShiftCtrl')).default,
        resolveObj: {
          shift: () => shiftToDisplay,
          notification: () => notification,
          fromExchange: () => false,
          activityLogItem: () => null,
        },
      };
    }

    return {
      modalView: shiftSwapNotificationModalUrl,
      ctrlSelector: ShiftSwapNotificationModalCtrl,
      resolveObj: {
        swapDetails: () => notification.items[0],
        notification: () => notification,
      },
    };
  }

  getSelfInviteModal(notification) {
    return {
      modalView: selfInviteNotificationModalUrl,
      ctrlSelector: SelfInviteNotificationModalCtrl,
      resolveObj: {
        notification: () => notification,
      },
    };
  }

  shouldOpenReactNotification = (notification) => {
    return (
      REACT_NOTIFICATION_TYPES.includes(notification.type) ||
      REACT_NOTIFICATION_ROUTES.includes(notification.route)
    );
  };

  async openNotificationModal(notification) {
    if (!notification) {
      return false;
    }

    const isReactNotification = this.shouldOpenReactNotification(notification);
    if (isReactNotification) {
      this.ReactNotificationService.openReactNotificationModal(notification);
      return true;
    }

    let modalView;
    let ctrlSelector = false;
    let controllerProvider;
    let resolveObj;

    // returns true if no modal
    const routeHandlers = {
      '/availability/view': () => {
        this.$state.go('users.profile', {
          userId: notification.items[0].user.id,
          tab: 'availability',
          unavailabilityId: notification.items[0].id,
        });
        return true;
      },
      '/profile': () => {
        this.$state.go('users.profile', { userId: this.Authentication.user.id, tab: 'profile' });
        return true;
      },
      '/availability': () => {
        this.$state.go('users.profile', {
          userId: this.Authentication.user.id,
          tab: 'availability',
        });
        return true;
      },
      '/settings/preferences': () => {
        this.$state.go('settings', { tab: 'preferences' });
        return true;
      },
      '/settings/notifications': () => {
        this.$state.go('settings', { tab: 'notifications' });
        return true;
      },
      '/settings/org': () => {
        this.$state.go('settings', { tab: 'orgSettings' });
        return true;
      },
      '/settings/integrations': () => {
        this.$state.go('settings', { tab: 'integrations' });
        return true;
      },
      '/appstore/ios': () => {
        this.$window.open(
          'https://itunes.apple.com/us/app/sling-stay-in-sync-your-team/id922995624?mt=8',
          '_blank'
        );
        return true;
      },
      '/appstore/android': () => {
        this.$window.open(
          'https://play.google.com/store/apps/details?id=com.gangverk.sling',
          '_blank'
        );
        return true;
      },
      '/conversations/start': () => {
        if (notification.actor) {
          this.ConversationService.openConversation(notification.actor.id);
        } else {
          this.ConversationService.createNewConversation();
        }
        return true;
      },
      '/account/billing': () => {
        this.$state.go('account.overview.billing');
        return true;
      },
      '/tasks/view': () => {
        ({ modalView, ctrlSelector, controllerProvider, resolveObj } =
          this.getNotificationTaskModal(notification));
      },
      '/announcements/view': () => {
        ({ modalView, ctrlSelector, controllerProvider, resolveObj } =
          this.getNotificationAnnouncementModal(notification));
      },
      '/leave/view': () => {
        ({ modalView, ctrlSelector, controllerProvider, resolveObj } =
          this.getNotificationLeaveModal(notification));
      },
      '/shifts/view': () => {
        ({ modalView, ctrlSelector, controllerProvider, resolveObj } =
          this.getNotificationShiftModal(notification));
      },
      '/shifts/repeating/view': () => {
        ({ modalView, ctrlSelector, controllerProvider, resolveObj } =
          this.getNotificationShiftModal(notification));
      },
      '/timeclock/timesheets': () => {
        ({ modalView, ctrlSelector } = this.getNotificationTimesheetsModal(notification));
      },
      '/shifts/exchange': () => {
        ({ modalView, ctrlSelector, controllerProvider, resolveObj } =
          this.getNotificationShiftSwapModal(notification));
      },
      '/users/self-invite': () => {
        ({ modalView, ctrlSelector, controllerProvider, resolveObj } =
          this.getSelfInviteModal(notification));
      },
      '/users/documents': () => {
        this.$state.go('dashboard.manage.users.profile', {
          userId: notification.items[0].user.id,
          tab: 'documents',
          documentId: notification.items[0].id,
        });
        return true;
      },
    };

    if (notification.route in routeHandlers) {
      const noModal = routeHandlers[notification.route]();
      if (noModal) {
        return;
      }
    } else {
      const match =
        notification.route && notification.route.match(/^\/conversations\/([0-9]+)\/([^/]+)$/);
      if (match) {
        this.$state.go('messages.detail', { conversationId: match[1], conversationName: match[2] });
      } else {
        console.log('unsupported notification route', notification.route);
      }

      return;
    }

    if (notification.route.includes('shift')) {
      await this.ShiftUtils.loadAsync();
    }

    let backDrop = true;
    let keyboard = true;

    if (notification.category === 'announcement' && !notification.archived) {
      backDrop = 'static';
      keyboard = false;
    }

    this.$uibModal
      .open({
        templateUrl: modalView,
        backdrop: backDrop,
        keyboard,
        controller: ctrlSelector,
        controllerProvider,
        controllerAs: 'ctrl',
        resolve: resolveObj,
        size: '620',
      })
      .result.ignoreCancel();
  }
}
